<template>
    <div>
        <div :class="[activeReciever === index ? 'opacity-100' : 'opacity-50']" class="rerciever_list"
            v-for="(reciever, index) in getReceieverWithPackages" :key="index + 'reciever'">
            <div>{{ index + 1 }}. <span class="capitalize"> {{ reciever.name || reciever.contactName || 'N/A' }}
                </span> |
                <span> {{ reciever && reciever.package && reciever.package.shipmentType ?
                    `${reciever.package.shipmentType +
                    ' Package '}` : '' }}
                    | {{ reciever && reciever.package && reciever.package.description ?
                        reciever.package.description : '' }} | {{ reciever && reciever.package &&
                        reciever.package.estimatedWeight ?
                        reciever.package.estimatedWeight : '' }}{{ reciever.package ? reciever.package.unitOfWeight : "" }}
                </span>
            </div>
            <div class="flex items-center">
                <span @click="viewEditPackage(index)" class="icon mr-3"><img alt="imgs_icon" class="img_icon"
                        src="./icons/eyeicon.svg" /></span>
                <span @click="deleteEditPackage(index)" class="icon"><img alt="" class="img_icon_del"
                        src="./icons/deleteIcon.svg" /></span>
            </div>
        </div>

        <div class="w-full flex flex-wrap mt-1 gap-4 pt-3 pb-2 mb-0">
            <div class="w-full pt-4 font-semibold text-sm mb-2">Select a Package Size</div>
            <div>
                <label for="noEnd" class="radio-label">
                    <input class=" bg-primary-yellow text-secondary-yellow" name="routeEnd" type="radio" id="noEnd"
                        value="light" v-model="packageForm.shipmentType" />
                    <i class="mx-2"><img src="./icons/lightPackage.svg" /> </i>
                    Light Package <span></span>
                </label>
            </div>

            <div>
                <label for="yesEnd" class="radio-label">
                    <input type="radio" v-model="packageForm.shipmentType" value="heavy" id="yesEnd" name="routeEnd" />
                    <i class="mx-2"> <img class="w-5" src="./icons/heavyPackage.svg" /></i>
                    Cargo/Heavy Package <span></span>
                </label>
            </div>

            <div>
                <label for="yesFinish" class="radio-label">
                    <input type="radio" v-model="packageForm.shipmentType" value="truck" id="yesFinish"
                        name="routeEnd" />
                    <i class="mx-2"><img src="./icons/haulageIcon.svg" /></i>
                    Haulage <span></span>
                </label>
            </div>
        </div>


        <div class="row justify-content-between" v-if="isLight(packageForm.shipmentType)">
            <div class="col-md-8 text-end float-right">
                <div class="mx-3 my-4">
                    <!-- <base-checkbox /> -->
                    <label for="confirm-package-size"
                        class="check-label text-danger label text-left flex items-start"><img
                            src="./icons/warning_icon.svg" class="mr-2 mt-1" /> Item dimension should be less or equal
                        to 50 x 40 x 40 (cm) and the gross weight should weight 5kg or less.</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mx-3 my-4 float-right">
                    <button @click="showPackageGuidlineModal = !showPackageGuidlineModal"
                        class="border rounded p-1 text-success border-success">
                        See Package Guidelines
                    </button>
                </div>
            </div>
        </div>

        <div>
            <div class="p-0 pb-0 flex flex-wrap justify-between rounded-lg bx-box">
                <div class="slice-option force__style">
                    <label class="label">Shipment Category</label>
                    <el-select filterable @input="updateShipDesc({ shipmentCategory: $event.target.value })"
                        v-model="packageForm.shipmentCategory" placeholder="Select">
                        <el-option v-for="catagory in lightCategory" :key="catagory" :label="catagory"
                            :value="catagory"></el-option>
                    </el-select>
                </div>

                <div class="slice-option">
                    <label class="label">Shipment Description</label>
                    <input @input="updateShipDesc({ description: $event.target.value })"
                        v-model="packageForm.description" type="text" placeholder="Describe its content"
                        class="input-mini" />
                </div>

                <div class="slice-option force__style" v-if="!isLight(packageForm.shipmentType)">
                    <div class="flex justify-between items-center">
                        <label class="label">Package Type</label>
                    </div>
                    <el-select filterable @input="updateShipDesc({ packageType: $event.target.value })"
                        v-model="packageForm.packageType" placeholder="Select handling requirements">
                        <el-option v-for="type in ['Boxed', 'Sacked', 'Crated', 'Pallet']" :key="type" :label="type"
                            :value="type">
                        </el-option>
                    </el-select>
                </div>
                <div class="slice-option force__style" v-if="!isLight(packageForm.shipmentType)">
                    <label class="label">Unit for Weight</label>
                    <el-select @input="updateShipDesc({ unitOfWeight: $event.target.value })"
                        v-model="packageForm.unitOfWeight" placeholder="Select Type">
                        <el-option label="milligram" value="mg"></el-option>
                        <el-option label="gram" value="g"></el-option>
                        <el-option label="kilogram" value="kg"></el-option>
                        <el-option label="ounce" value="oz"></el-option>
                        <el-option label="pound" value="lb"></el-option>
                        <el-option label="metric tonne" value="mt"></el-option>
                        <el-option label="ton" value="t"></el-option>
                    </el-select>
                </div>

                <div class="dim_width slice-option" v-if="!isLight(packageForm.shipmentType)">
                    <label class="label">Item dimension </label>
                    <div class="flex items-center gap-2 flex-row">
                        <input type="number" @input="updateShipDesc({ length: $event.target.value })" min="0"
                            v-model="packageForm.length" placeholder="L" class="p-2 text-field mr-1 mar_top" />
                        <input type="number" @input="updateShipDesc({ width: $event.target.value })" min="0"
                            v-model="packageForm.width" placeholder="W" class="p-2 text-field dim_width mx-1 mar_top" />
                        <input type="number" placeholder="H" @input="updateShipDesc({ height: $event.target.value })"
                            min="0" v-model="packageForm.height" class="p-2 text-field dim_width ml-1 mar_top" />
                        <div class="dim_dropdown force__style" v-if="!isLight(packageForm.shipmentType)">
                            <el-select @input="updateShipDesc({ unitOfDimension: $event.target.value })"
                                v-model="packageForm.unitOfDimension" placeholder="Select Type" class="w-full">
                                <el-option label="millimeter" value="mm"></el-option>
                                <el-option label="centimeter" value="cm"></el-option>
                                <el-option label="meter" value="m"></el-option>
                                <el-option label="kilometer" value="km"></el-option>
                                <el-option label="inch" value="in"></el-option>
                                <el-option label="feet" value="ft"></el-option>
                                <el-option label="yard" value="yd"></el-option>
                            </el-select>
                        </div>
                    </div>

                </div>
                <!-- 
                <div class="dim_width slice-option" v-if="!isLight(packageForm.shipmentType)">
                    <label class="label">Item Width </label>
                    <input type="number" @input="updateShipDesc({ width: $event.target.value })" min="0"
                        v-model="packageForm.width" placeholder="Specify" class="p-2 text-field dim_width mx-1" />
                </div>

                <div class="dim_width slice-option" v-if="!isLight(packageForm.shipmentType)">
                    <label class="label">Item Height</label>
                    <input type="number" placeholder="Specify" @input="updateShipDesc({ height: $event.target.value })"
                        min="0" v-model="packageForm.height" class="p-2 text-field dim_width ml-1" />
                </div> -->

                <div class="slice-option">
                    <label class="label">Total estimated weight({{ packageForm.unitOfWeight }})</label>
                    <input @input="updateShipDesc({ weight: $event.target.value })" type="number" min="1"
                        v-model="packageForm.estimatedWeight" placeholder="-- Enter --" class="input-mini" />
                </div>



                <div class="slice-option">
                    <label class="label">Quantity</label>
                    <input @input="updateShipDesc({ quantity: $event.target.value })" type="number" min="1"
                        v-model="packageForm.quantity" placeholder="-- Enter --" class="input-mini" />
                </div>

                <div class="slice-option">
                    <label class="label">Total Value of Items (NGN)</label>
                    <input @input="updateShipDesc({ totalValue: $event.target.value })" type="number" min="0"
                        v-model="packageForm.itemValue" placeholder="-- Enter --" class="input-mini" />
                </div>

                <div class="slice-option">
                    <div class="flex justify-between items-center mt-0">
                        <label class="label_handling">Special handling?</label>
                        <div class="w-full flex mt-1 gap-4 justify-end">
                            <label :for="'handlingNo'" class="radio-label">
                                <input class="bg-primary-yellow text-secondary-yellow" :name="'handling'" type="radio"
                                    :id="'handlingNo'"
                                    @input="updateShipDesc({ isSpecialHandling: $event.target.value })" value="no"
                                    v-model="packageForm.isSpecialHandling" />
                                No
                                <span></span>
                            </label>

                            <label :for="'handlingYes'" class="radio-label">
                                <input type="radio" v-model="packageForm.isSpecialHandling" value="yes"
                                    :id="'handlingYes'" :name="'handling'"
                                    @input="updateShipDesc({ isSpecialHandling: $event.target.value })" />
                                Yes
                                <span></span>
                            </label>
                        </div>
                    </div>
                    <el-select @input="getSpecialHandling($event)" v-model="packageForm.specialHandling" multiple
                        :disabled="packageForm.isSpecialHandling == 'no'" placeholder="Special handling options">
                        <el-option v-for="option in handlingOptions" :key="option.value" :label="option.title"
                            :value="option.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="w-full mt-3">
                    <label class="label">Delivery Instructions</label>
                    <textarea @input="checkTextlength($event)" type="number" v-model="packageForm.deliveryNote"
                        placeholder="Additional Notes (Optional)" class="input-mini_textarea"></textarea>
                    <div>
                        {{ packageForm.deliveryNote.length }}/300
                    </div>
                </div>

                <div class="flex flex-wrap w-full mb-3 mt-4">
                    <div v-for="(img, index) in packageForm.packageImages" :key="index + 'img_package'"
                        class="img__contain">
                        <img class="std_img" :src="img" />
                        <button @click="deletePackageImage(index)" class="img_contain_cancle">&#x2715;</button>
                    </div>
                </div>

                <!-- // upload image component -->
                <PackageImageUpload :updateStoreNoEvent="updateStoreNoEvent" :packageForm="packageForm" />

                <div class="w-full pb-10 mt-4 flex items-center">
                    <hr class="w-full mr-3" />
                    <button :class="[canAddAnother ? 'opacity-100' : 'opacity_disable']" class="add_receiver_btn"
                        @click="saveRecieveDetailPackage">
                        <img src="./icons/addicon.svg" class="plus_img mr-0" />Save & Add Another
                    </button>
                </div>
            </div>
        </div>
        <div class="flex w-full items-center justify-end py-4 px-4">
            <button class="underline mr-5" @click="goBack">
                Back
            </button>
            <primary-button @click="checkAllRecievers" class="shadow-md font-normal" buttonText="Continue"
                :loading="loading" />
        </div>

        <AddAnotherPackage @setActiveUser="setActiveUser" :activeReciever="activeReciever"
            :show-modal="showAddPackageModal" @closeModal="showAddPackageModal = false" />
        <PackageGuidlineModal :show-modal="showPackageGuidlineModal" @closeModal="showPackageGuidlineModal = false" />
        <CheckAllRecieversPackage :extractedInfos="extractedInfos" :show-modal="showPackageCheckpackagesModal"
            :receiversWithoutPackages="receiversWithoutPackages" :contimueToPayment="contimueToPayment"
            @close-modal="showPackageCheckpackagesModal = false" />
        <ShippingService
        :show-modal="showShippingServiceModal" @close-modal="showShippingServiceModal = false"
        :bookingLoading="loading"
            :createdBooking="createdBooking" @updateBookinWithShippingService="updateBookinWithShippingService" />
    </div>
</template>

<script>

import AddAnotherPackage from './modals/AddAnotherPackage.vue'
import CheckAllRecieversPackage from './modals/CheckAllRecieversPackage.vue'
import PackageGuidlineModal from './modals/PackageGuidlineModal.vue'
import PackageImageUpload from "./module/components/UploadImageAction.vue"
import ShippingService from './modals/ShippingService.vue'


export default {
    name: 'bookingPackages',
    components: {
        AddAnotherPackage,
        PackageGuidlineModal,
        CheckAllRecieversPackage,
        PackageImageUpload,
        ShippingService
    },
    data() {
        return {
            showAddPackageModal: false,
            recieverDetailPackage: [],
            showPackageGuidlineModal: false,
            showPackageCheckpackagesModal: false,
            loading: false,
            showShippingServiceModal: false,
            lightCategory: [
                "Parcel", "Document", "Electronic Device", "Food",
                "Medicines & Pharmaceuticals", "Beauty Products",
                "Fashion", "Books", "Others"
            ],
            handlingOptions: [
                { value: "fragile", title: "Fragile" },
                { value: "oversized", title: "Over-sized" },
                { value: "Confidential", title: "Confidential" },
                { value: "packagehandling", title: "⁠Package-handling" },
                { value: "inflammable", title: 'inflammable' },
                { value: "⁠radioactive", title: "Radioactive" },
            ],
            extractedInfos: [],
            recieverWithNoPackage: [],
            activeReciever: 0,
            justEntered: true,
            testStore: {},
            createdBooking: {},
            packageForm: {
                shipmentType: 'light',
                shipmentCategory: '',
                description: '',
                estimatedWeight: undefined,
                quantity: '',
                itemValue: '',
                id: undefined,
                isSpecialHandling: 'no',
                specialHandling: '',
                unitOfWeight: 'kg',
                deliveryNote: '',
                packageType: "",
                unitOfDimension: "cm",
                packageImages: []
            },
        }
    },
    computed: {
        locationId() {
            return this.$store.getters.currentLocationId;
        },
        canAddAnother() {
            const { shipmentCategory, description, quantity, itemValue } = this.packageForm
            return shipmentCategory != "" && description != "" && quantity != "" && itemValue != ""
        },
        getCreatedShipment() {
            return this.$store.getters.getCreatedBooking?.id ? this.$store.getters.getCreatedBooking : this.$store.getters.latestNewBooking?.shippingInformation;
        },
        getReceieverWithPackages() {
            return this.$store.getters.getSavedNewRecieverPackage;
        }
    },
    watch: {
        "$store.getters.getSavedNewRecieverPackage"(val) {
            this.testStore = val
        },
        "packageForm.isSpecialHandling"(val) {
            this.updateStoreNoEvent(val, 'isSpecialHandling')
        },
    },
    activated() {
        if (this.$store.getters.getSavedNewRecievers.length < 1) return
        let savedReceiversPackages = this.$store.getters.getSavedNewRecievers.map((item) => ({
            ...item,
            package: item?.package?.shipmentType ? item?.package : {
                shipmentType: 'light',
                shipmentCategory: '',
                description: '',
                estimatedWeight: undefined,
                quantity: '',
                itemValue: '',
                id: undefined,
                isSpecialHandling: 'no',
                specialHandling: '',
                unitOfWeight: 'kg',
                deliveryNote: '',
                packageImages: []
            }
        }));

        if (this.justEntered) {
            this.$store.dispatch('setSavedNewRecieverPackages', [savedReceiversPackages[0]]);
            this.justEntered = false;
        } else {
            this.viewEditPackage(0)
        }

    },
    methods: {
        getSpecialHandling(val) {
            this.updateShipDesc({ specialHandling: val });
        },
        isLight(val) {
            return val == "light";
        },
        isHeavy(val) {
            return val == "heavy";
        },
        isTruck(val) {
            return val == "truck";
        },
        hasTruckShippingType(data) {
            return data.some(entry =>
                entry.packagees?.some(pkg => pkg.shipmentType === 'truck')
            );
        },
        groupReceivers(data) {
            const receiverMap = new Map();
            data.forEach(item => {
                const key = `${item?.name}-${item?.email}-${item?.mobile}`; // Unique key for each receiver

                if (!receiverMap.has(key)) {
                    // Create a new receiver object
                    receiverMap.set(key, {
                        type: item.type,
                        contactName: item.contactName,
                        name: item.name,
                        email: item.email,
                        mobileNumberType: item.mobileNumberType,
                        addressType: item.addressType,
                        address: item.address,
                        mobile: item.mobile,
                        isEdit: item.isEdit,
                        pickUpTime: item.pickUpTime,
                        sendShippingUpdates: item.sendShippingUpdates,
                        nameSelect: item.nameSelect,
                        id: item?.id,
                        packagees: []
                    });
                }

                // Add the package details to the receiver
                receiverMap.get(key).packagees.push(item?.package);
            });

            return Array.from(receiverMap.values()); // Convert map to array
        },
        returnRecieversAndPackageNumber() {
            let extractdata = this.groupReceivers(this.$store.getters.getSavedNewRecieverPackage).map((item) => {
                return {
                    ...item,
                    name: item?.name || item?.contactName,
                    email: item?.email,
                    mobile: item?.mobile,
                    packageLenght: item?.package?.length,
                    package: item?.package
                }
            })

            return extractdata
        },
        checkAllRecievers() {
            if (this.receiversWithoutPackageDetail()) {
                this.generateToast("Please Fill importatnt Package Information to proceed", "error");
                return
            }
            this.receiversWithoutPackages();
            this.extractedInfos = this.returnRecieversAndPackageNumber();
            this.receiversWithoutPackages().length > 0 ? (this.showPackageCheckpackagesModal = true) : this.contimueToPayment()
        },
        getAllPackages(response) {
            let emptyArray = [];
            response?.data?.data?.shipment?.shipmentReceiever.forEach((item) => {
                const modifiedPackages = item.packagees.map((pkg) => ({
                    ...pkg, // -- Keep existing package properties -- AZUDI
                    recieverId: item.locationId // -- Add the receiver property -- AZUDI
                }));

                emptyArray.push(...modifiedPackages);
            });

            let cloneRecieverPackages = this.getReceieverWithPackages
            let retrieveArray = emptyArray.map((item, index) => {
                return {
                    ...cloneRecieverPackages[index],
                    id: item.recieverId,
                    package: {
                        ...cloneRecieverPackages[index]?.package,
                        id: item.id
                    }
                }
            });
            this.$store.dispatch('setSavedNewRecieverPackages', retrieveArray);
        },
        async contimueToPayment() {
            this.loading = true;
            try {
                this.showPackageCheckpackagesModal = false;
                let payload = {
                    sender: this.$store.getters.getSavedNewSender,
                    receiver: this.groupReceivers(this.$store.getters.getSavedNewRecieverPackage),
                    shippingMethod: this.$store.getters.getNewBookingShippingMethod,
                    id: this.getCreatedShipment?.id,
                    deliveryStatus: this.$store.getters.getNewQuoteStatus,
                    userId: JSON.parse(localStorage.getItem('loggedInUser'))?.id,
                    mileType: this.$store.getters.getIsInterState ? "INTER" : "INTRA",
                    terminalId: this.$_3pl ? this.locationId : this.$store.getters?.getActiveShippingService?.takeOffId
                }
                let response = await this.$_createNewBooking(payload);
                this.$store.dispatch('setCreatedBookingPayload', payload)

                this.setSenderId(response);
                this.setRecieverIds(response);
                this.getAllPackages(response);
                this.activeReciever = null;
                this.packageForm = {
                    shipmentType: 'light',
                    shipmentCategory: '',
                    description: '',
                    estimatedWeight: undefined,
                    quantity: '',
                    itemValue: '',
                    id: undefined,
                    isSpecialHandling: 'no',
                    specialHandling: '',
                    unitOfWeight: 'kg',
                    deliveryNote: '',
                    packageImages: []
                }
                this.createdBooking = response.data.data.shipment;
                this.$store.dispatch("setSavedCreatedShipment", response.data.data.shipment)
                this.hasTruckAction()

            } catch (error) {
               this.handleError(error)
            } finally {
                this.loading = false
            }
        },
        hasTruckAction() {
            const shippingmethod = this.$store.getters.getNewBookingShippingMethod;
            const isInterstate = this.$store.getters.getIsInterState;
            const idD2Tinterstate = isInterstate && shippingmethod === "door-to-door"

            const isT2T = shippingmethod === "terminal-to-terminal" || shippingmethod === "terminal-to-door" || idD2Tinterstate
            const hasTruckShipping = this.hasTruckShippingType(this.groupReceivers(this.$store.getters.getSavedNewRecieverPackage)) || isT2T
            if (hasTruckShipping) { this.showShippingServiceModal = true }
            else {
                this.$store.dispatch('setSavedActiveTab', 3);
            }
        },
        async updateBookinWithShippingService(shippingService, deliveryClass) {
            if (!shippingService) return;
            this.loading = true;
            try {
                  let payload = {
                sender: this.$store.getters.getSavedNewSender,
                receiver: this.groupReceivers(this.$store.getters.getSavedNewRecieverPackage),
                shippingMethod: this.$store.getters.getNewBookingShippingMethod,
                id: this.createdBooking?.id,
                userId: JSON.parse(localStorage.getItem('loggedInUser'))?.id,
                shippingServiceId: shippingService,
                deliveryStatus: this.$store.getters.getNewQuoteStatus,
                deliveryClass: deliveryClass,
                mileType: this.$store.getters.getIsInterState ? "INTER" : "INTRA",
                terminalId: this.$_3pl ? this.locationId : this.$store.getters?.getActiveShippingService?.takeOffId
            }
            const rresponse = await this.$_createNewBooking(payload);
            this.$store.dispatch('setCreatedBookingPayload', payload)
            this.$store.dispatch("setSavedCreatedShipment", rresponse.data.data.shipment)
            this.createdBooking = rresponse.data.data.shipment;
            this.$store.dispatch('setSavedActiveTab', 3);
            } catch (error) {
                this.handleError(error)
            } finally {
                this.loading = false
            }
        },
        setSenderId(response) {
            let newSenderinfo = { ...this.$store.getters.getSavedNewSender, id: response?.data?.data?.shipment?.shipperLocationId };
            this.$store.dispatch('setSavedNewSender', newSenderinfo);
        },
        setRecieverIds(response) {
            let newRecieversinfo = this.$store.getters.getSavedNewRecievers.map((elem, index) => {
                return {
                    ...elem,
                    id: response?.data?.data?.shipment?.shipmentReceiever[index]?.locationId
                }
            })
            // let newRecieversPackageinfo = this.getReceieverWithPackages.map((elem, index) => {
            //     return {
            //         ...elem,
            //         id: response?.data?.data?.shipment?.shipmentReceiever[index].id
            //     }
            // })
            this.$store.dispatch('setSavedNewRecievers', newRecieversinfo)
            // this.$store.dispatch('setSavedNewRecieverPackages', newRecieversPackageinfo)
        },
        receiversWithoutPackages() {
            let extractdata = this.groupReceivers(this.$store.getters.getSavedNewRecieverPackage);
            const noRecieverPackaes = this.$store.getters.getSavedNewRecievers.filter(receiver => {
                return !extractdata.some(item => (item.name || item.contactName) === (receiver.name || receiver.contactName));
            })
            this.recieverWithNoPackage = noRecieverPackaes;
            return noRecieverPackaes || [];
        },
        receiversWithoutPackageDetail() {
            let extractdata = this.groupReceivers(this.$store.getters.getSavedNewRecieverPackage);
            const { shipmentCategory, estimatedWeight, itemValue, quantity } = extractdata[0].packagees[0];
            let isRecieverPkghasNotData = extractdata.length >= 1 && (estimatedWeight == undefined || itemValue == "" || shipmentCategory == "" || quantity == "")
            return isRecieverPkghasNotData;
        },
        deleteEditPackage(index) {
            if (this.$store.getters.getSavedNewRecieverPackage.length < 2) {
                this.generateToast("Sorry you cannot delete the last package, Please add another package", 'error')
                return;
            }
            let filteredrecieverPackage = this.$store.getters.getSavedNewRecieverPackage.filter((item, ind) => index !== ind);
            this.recieverDetailPackage = filteredrecieverPackage;
            this.$store.dispatch('setSavedNewRecieverPackages', filteredrecieverPackage);
            this.activeReciever = null;
            this.packageForm = {
                shipmentType: 'light',
                shipmentCategory: '',
                description: '',
                estimatedWeight: undefined,
                quantity: '',
                itemValue: '',
                id: undefined,
                isSpecialHandling: 'no',
                specialHandling: '',
                unitOfWeight: 'kg',
                deliveryNote: '',
                packageImages: []
            }
        },
        viewEditPackage(index) {
            this.activeReciever = index;
            this.packageForm = this.$store.getters?.getSavedNewRecieverPackage[index]?.package
        },
        deletePackageImage(index) {
            let activePackageImages = [...(this.packageForm?.packageImages || [])];

            if (index < 0 || index >= activePackageImages.length) return; // Prevent out-of-bounds errors

            activePackageImages.splice(index, 1);
            this.packageForm.packageImages = activePackageImages;
            this.updateShipDesc({ packageImages: activePackageImages });
        },
        updateStoreNoEvent(val, name) {
            switch (name) {
                case 'packageImages':
                    this.updatePackageimages(val)
                    break;
            }
        },
        updatePackageimages(val, index) {
            let activePackaeImages = this.packageForm?.packageImages || []

            let PackaeImages;
            if (index) {
                PackaeImages = activePackaeImages.filter(item => item == val);
            } else {
                activePackaeImages.push(val);
                PackaeImages = [...activePackaeImages]; // or just use activePackaeImages
            }
            this.updateShipDesc({ packageImages: PackaeImages })
        },
        updateShipDesc(val) {
            if (!this.activeReciever && isNaN(this.activeReciever) || this.$store.getters.getSavedNewRecievers.length < 1) return;
            let cloneRecieverpack = this.getReceieverWithPackages;
            if (cloneRecieverpack[this.activeReciever]) {
                cloneRecieverpack[this.activeReciever].package = {
                    ...this.packageForm,
                    ...val,
                };
            }
            this.$store.dispatch('setSavedNewRecieverPackages', cloneRecieverpack);
        },
        goBack() {
            this.$store.dispatch('setSavedActiveTab', 1)
        },
        setActiveUser(index) {
            this.activeReciever = index;
            this.recieverDetailPackage = this.getReceieverWithPackages;
            this.packageForm = {
                shipmentType: 'light',
                shipmentCategory: '',
                description: '',
                estimatedWeight: undefined,
                quantity: '',
                itemValue: '',
                id: undefined,
                isSpecialHandling: 'no',
                specialHandling: '',
                unitOfWeight: 'kg',
                deliveryNote: '',
                packageImages: []
            }
        },
        saveRecieveDetailPackage() {
            const { itemValue, quantity, estimatedWeight } = this.packageForm;
            if (!(itemValue || quantity || estimatedWeight) || !this.canAddAnother) return;

            let recieverDetailPackage = this.getReceieverWithPackages;
            recieverDetailPackage[this.activeReciever] = {
                ...(recieverDetailPackage[this.activeReciever] || {}),
                package: { ...this.packageForm },
            };

            this.$store.dispatch('setSavedNewRecieverPackages', recieverDetailPackage);
            this.showAddPackageModal = true;
        },
        checkTextlength(event) {
            let value = event.target.value;
            if (this.packageForm.deliveryNote.length > 300) {
                this.packageForm.deliveryNote = value.substring(0, 300);
                return;
            }
            this.packageForm.deliveryNote = value;
        },
    },
}
</script>

<style lang="scss">
.force__style>.el-select>.el-input>input {
    @apply text-[inherit] bg-primary-lightblue h-[43px] rounded-lg
}

.dim_dropdown {
    @apply mt-0 !w-[100px] h-[50px];
}

.mar_top {
    @apply -mt-2 text-center
}

.dim_width {
    display: block;
}

.dim_width input {
    width: 100%;
}

.opacity_disable {
    opacity: 0.45;
    cursor: not-allowed
}

.std_img {
    @apply rounded-md w-full h-[100px] object-fill
}

.img_contain_cancle {
    @apply absolute w-[18px] h-[18px] -top-1 -right-1 bg-primary-yellow rounded-full text-center text-black-default font-bold text-xs inline-flex items-center justify-center;
}

.img__contain {
    @apply w-[150px] mr-4 mb-3 relative
}

.rerciever_list {
    @apply flex justify-between items-center bg-primary-lightgrey py-2 px-2 mt-5;
}

.add_receiver_btn {
    @apply text-primary-yellow font-semibold w-[250px] flex items-center justify-around
}

.radio-label {
    @apply flex items-center mr-2;
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue resize-none;
}

.input-mini_textarea {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue resize-none h-24;
}

.slice-option {
    @apply mt-4 sm:mt-4 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.label_handling {
    @apply mt-1;
    white-space: nowrap;
}

.radio-label span::after {
    @apply bg-secondary-yellow
}

.img_icon {
    width: 17px;
    cursor: pointer;
}

.img_icon_del {
    width: 11px;
    cursor: pointer;
}

.text-field {
    @apply px-3 border-2 border-gray-200 rounded-md !w-[24%] bg-primary-lightblue;
}
</style>